<!--线下培训详情-->
<!--wj-->
<template>
    <div class="OfflineDetail">
        <detail-title></detail-title>
        <img :src="offList.tsotLogo"  :onerror="logo" class="offBanner" style="width:100%;padding-top:5rem;"/>
        <div class="offline-detail">
            <p class="offline-title"><strong v-html="offList.tsotName">{{offList.tsotName}}</strong></p>
            <p class="offline-teach">开课时间：{{offList.tsotStartDate}}
            </p>
            <p class="offline-teach">培训讲师：{{offList.tsotTech}}</p>
            <p class="offline-teach">培训地点：{{offList.tsotAdd}}</p>
            <p class="offline-location">咨询电话：{{offList.tsotTel}}</p>
            <p><span v-for="(v,index) in offList.tsotKey" :key="index" class="offline-tab">{{v}}</span></p>
        </div>
        <div class="bbs-line"></div>
        <p class="offline-jj">课程简介</p>
        <div class="offline-detail">
            <p class="offline-intro" v-html="offList.tsotDesc">{{offList.tsotDesc}}</p>
        </div>
         <el-row class="Offline-footer">
                <el-col :span="8">
                    <p class="off-fire"><strong>{{offList.tsotPrice}}</strong></p>
                    <p style="color:#969696;">已有{{count}}人报名</p>
                </el-col>
                <el-col :span="8" class="off-zixun">
                    <a v-bind:href="offList.phoneCall"><img src="@/assets/image/tell3.svg" class="Off-tel">咨询</a>
                    <span style="color:rgb(230,232,232);">|</span>
                </el-col>
                <el-col :span="8" >
                    <button  type="button"  class="Offline-btn" @click="SignUpBtn()">下载app报名</button>
                </el-col>
        </el-row>
        <!-- <span class="Offline-footer">
            <button type="button" class="Offline-btn"  ><a v-bind:href="offList.phoneCall"><img src="@/assets/image/offline_tel.svg"  class="Offline-tel">马上报名</a></button>
        </span> -->
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from 'axios';
import DetailTitle from '@/components/DetailTitle';
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
export default {
    name:'OfflineDetail',
    data() {
        return {
            offList:[],
            count:'',
            logo: 'this.src="' + require("@/assets/image/gg1.jpg") + '"',
        };
    },
    mounted(){
        const that = this;
        var id="";
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
          if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[2];
          }else{
            var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
            var strs = str.split("?");
            id = strs[1];   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
          }
        }
        var search = '';
        const loading = that.$loading({//加载延时提示
            lock: true,
            text: '正在获取数据',
            spinner: 'el-icon-loading',
            color:'#f3f3f3',
            background: 'rgba(250, 250, 250, 0.01)',
        });
        Axios.get(that.$store.state.APIURLS+"Tsot/findByIdEs?"+ id +"&search="+search).then(function(res) {
            if(res.data.code == 200){
                loading.close();
                that.count = res.data.data.count;
                res.data.data.tost.phoneCall = "tel:" +res.data.data.tost.tsotTel;//咨询电话
                if(res.data.data.tost.tsotKey){
                    res.data.data.tost.tsotKey = res.data.data.tost.tsotKey.split(",");
                }
                if(res.data.data.tost.tsotPrice){
                    if(res.data.data.tost.tsotPrice == '0.00' || res.data.data.tost.tsotPrice == '0'){
                        res.data.data.tost.tsotPrice = '免费';
                    }else{
                        res.data.data.tost.tsotPrice = res.data.data.tost.tsotPrice;
                    }
                }else{
                    res.data.data.tost.tsotPrice = '免费'
                }
                that.offList = res.data.data.tost;
                var shareList = {
                    title: res.data.data.tost.tsotName,
                    content: res.data.data.tost.tsotDesc,
                };
                eventBus.$emit("shareList", shareList);
            }
        });
    },
    methods:{
        SignUpBtn(){
            const that = this;
            location.href='http://url.cn/59TtsAP';
        },
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>
<style>
@import "../assets/css/offlinedetail.css";
</style>

